import { $convertFromMarkdownString } from '@lexical/markdown';
import { protectEscapedMarkdownPunctuation } from '@main/shared/utils';
import { $setSelection, createEditor, LexicalEditor } from 'lexical';

import { restoreEscapedMarkdownPunctuationInDocument } from '../markdown/markdown-escapes';
import { MD_TRANSFORMERS } from '../markdown/transformers';
import { WysiwygBaseNodes } from './nodes';

/**
 * Converts a markdown string to Lexical editor state JSON
 * @param markdown - The markdown string to convert
 * @returns The Lexical editor state as a JSON string
 */
export function convertMarkdownToLexicalJSON(markdown: string, editor?: LexicalEditor): string {
  editor =
    editor ??
    createEditor({
      nodes: WysiwygBaseNodes,
      onError: (error) => {
        throw error;
      },
    });

  editor.update(
    () => {
      $convertFromMarkdownString(protectEscapedMarkdownPunctuation(markdown), MD_TRANSFORMERS);
      restoreEscapedMarkdownPunctuationInDocument();
      // Reset selection to avoid editor focus issues
      $setSelection(null);
    },
    { discrete: true },
  );

  return JSON.stringify(editor.getEditorState());
}
